import React, { useState, useEffect, useCallback, useTransition } from "react";
import axiosClient from "../../../../services/axiosClient";
import classNames from "classnames/bind";
import ModalInfo from "../ModalInfo/ModalInfo";
import useFetchData from "../../../../hooks/useFetchData";
import {
  SelectBox,
  Button,
  Pagination,
  Loading,
  SelectBoxItem,
  Alert,
  Toast,
} from "../../../../components";
import { Link, useNavigate } from "react-router-dom";
import { userManagement } from "../../../../services/api/userManagementApi";
import styles from "./User.module.css";
import TableUser from "./TableUser";
import ModalPermission from "./ModalPermisstion";
const cx = classNames.bind(styles);

const User = () => {
  const navigate = useNavigate();
  const [isModalInfo, setIsModalInfo] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [code, setCode] = useState("");
  const [isRefresh, setIsRefresh] = useState(false);
  const [loading, setLoading] = useState();
  const [data, setData] = useState([]);
  const [textSearch, setTextSearch] = useState();
  const [input, setInput] = useState();
  const [isAlert, setIsAlert] = useState();
  const [id, setId] = useState();
  const [pages, setPages] = useState(1);
  const [companyCode, setCompanyCode] = useState()
  const [status, setStatus] = useState({ code: '1', name: 'Hoạt động' })
  const [typeCode, setTypeCode] = useState({ name: 'Tất cả', code: 'All' })
  const [permission, setPermission] = useState()
  const [errorCode, setErrorCode] = useState(200)
  const ref = React.useRef(null);
  const [showModalPer, setShowModalPer] = useState(false);
  const [count, setCount] = useState(1)
  const showModal = (id) => {
    setIsModalInfo(true);
    setCode(id)
  };
  const companyUser = sessionStorage.getItem('company_code')
  useEffect(() => {
    async function getData() {
      const param = {
        page: currentPage,
        size: 10,
        name: textSearch === 'All' ? null : textSearch,
        company_code: companyCode === 'All' ? null : companyCode,
        status_code: status.code === 'All' ? null : status.code,
        usertype_code: typeCode.code === 'All' ? null : typeCode.code,
      };
      try {
        const res = await axiosClient.get(
          `/userManagement/get-list-user/`, { params: { ...param } }
        );
        setData(res.data);
        setLoading(false);
        if (res.count) {
          setPages(Math.ceil(res.count / 10));
        }
      } catch (error) {
        setLoading(false);
        if (error?.request?.status === 403) {
          Toast.open('Bạn không có quyền quản trị', 'danger')
          setErrorCode(403)
        } else {
          Toast.open('Không thể tải về danh sách', 'danger')
        }
      }
    }
    getData();
  }, [currentPage, isRefresh, textSearch, companyCode, status, typeCode]);

  const infoCurrentUser = useFetchData(`userManagement/get-user-info/?user_code=${code}`);
  const companies = useFetchData('/company/get-list-company/');
  const getListPermissions = useCallback(async (code) => {
    const res = await axiosClient.get(`/userType/get-list-userType/?company_code=${code}`)
    setPermission(res)
    return res;
  }, [])
  useEffect(() => {
    if (companyCode && companyCode !== 'All') {
      getListPermissions(companyCode)
    } else {
      getListPermissions(companyUser)
    }
  }, [companyCode, companyUser])

  const handleClick = (page) => {
    setCurrentPage(page);
  };

  const handleNext = () => {
    setCurrentPage(currentPage + 1);
  };

  const handlePrevious = () => {
    setCurrentPage(currentPage - 1);
  };

  const handleClose = () => {
    setIsModalInfo(false);
  };

  const handleOpenDetailPage = () => {
    navigate('/admin/user/info-detail')
  };

  const onChangeStatus = (data) => {
    let label = data === 'All' ? 'Tất cả' : data === '1' ? 'Hoạt động' : 'Không hoạt động';
    setCurrentPage(1);
    setStatus({ code: data, name: label });
  };

  const onChangeCompany = (data) => {
    if (companyCode !== data) {
      setCompanyCode(data);
      setPermission(null);
      setTypeCode({ name: 'Tất cả', code: 'All' })
      setCurrentPage(1)
    }
  };

  const onChangeTextSearch = (e) => {
    setInput(e.target.value);
    setCurrentPage(1)
    if (ref.current) {
      clearTimeout(ref.current);
    }
    ref.current = setTimeout(() => {
      const data = e.target.value;
      setTextSearch(data);
    }, 300);
  };

  const handleChangeUserType = (data) => {
    if (permission) {
      setCurrentPage(1)
      let index = permission?.data?.findIndex(item => item.CODE === data);
      if (index >= 0) {
        permission?.data?.forEach(item => {
          if (item.CODE === data) {
            setTypeCode({ name: item.SUBJECT_NAME, code: data })
          }
        })
      } else {
        setTypeCode({ name: 'Tất cả', code: 'All' })
      }
    }
  }

  const showAlert = (id) => {
    setIsAlert(true);
    setId(id);
  };

  const handleOk = async () => {
    try {
      const res = await userManagement.delete(id);
      if (res.result) {
        Toast.open("Xóa người dùng thành công", 'success')
        setIsAlert(false)
        setIsRefresh(!isRefresh)
      }

    } catch (e) {
      Toast.open("Xóa người dùng không thành công", 'danger');
    }
  };

  const showListPermission = (code, count) => {
    setShowModalPer(!showModalPer)
    setCode(code)
    setCount(count)
  }

  return (
    <>
      <div id="__notification"></div>
      {isAlert && <Alert type="alert" title="Bạn có muốn xóa không" onClose={(e) => setIsAlert(false)} onOk={handleOk} />}
      <div className={cx("header")}>
        <h1 className={cx("title")}>Quản trị người dùng</h1>
      </div>
      <div className={cx("content")}>
        <div className={cx("filter")}>
          <div className={cx("search")}>
            <input
              value={input}
              onChange={onChangeTextSearch}
              className={cx("search-input")}
              placeholder="Tìm kiếm..."
              maxLength={155}
            />
          </div>
          <div>
            <label className={cx("label")}>Trạng thái</label>
            <SelectBox
              style={{ paddingTop: 8 }}
              type="small"
              className={cx("select")}
              onChange={onChangeStatus}
              values={status.name}
            >
              <SelectBoxItem label="Tất cả" value="All" />
              <SelectBoxItem
                label={'Hoạt động'}
                value={'1'}
              />
              <SelectBoxItem
                label={'Không hoạt động'}
                value={'0'}
              />
            </SelectBox>
          </div>
          <div>
            <label className={cx("label")}>Đơn vị</label>
            <SelectBox
              style={{ paddingTop: 8 }}
              type="small"
              className={cx("select")}
              onChange={onChangeCompany}
            >
              <SelectBoxItem label={'Tất cả'} value={'All'} />
              {companies ? companies?.data?.data?.map((item) => {
                return (
                  <SelectBoxItem key={item.CODE} label={item.NAME}
                    value={item.CODE} />
                )
              }) : (
                <span></span>
              )}
            </SelectBox>
          </div>
          <div>
            <label className={cx("label")}>Quyền</label>
            <SelectBox
              style={{ paddingTop: 8 }}
              type="small"
              className={cx("select")}
              onChange={handleChangeUserType}
              values={typeCode.name}
            >
              <SelectBoxItem label={'Tất cả'} value={'All'} />
              {permission ? permission?.data?.map(item => {
                return (
                  <SelectBoxItem key={item.CODE} label={item.SUBJECT_NAME} value={item.CODE} />
                )
              }) : (
                <span></span>
              )}

            </SelectBox>
          </div>
          {errorCode !== 403 && (
            <div>
              <Link
                // onClick={handleCreate}
                to={"add-new-user"}
                style={{ textDecoration: "none" }}
              >
                <Button className={cx("btn")} title="Thêm mới người dùng" onClick={() => { return 0 }} />
              </Link>
            </div>
          )}
        </div>
        {!loading ? (
          <>
            <div className={cx('table-container')}>
              <TableUser
                data={data}
                showAlert={showAlert}
                showModal={showModal}
                showListPermission={showListPermission}
              />
            </div>
            {data && data.length > 0 && (
              <div className={cx("pagination")}>
                <Pagination
                  onClick={handleClick}
                  onNext={handleNext}
                  onPrevious={handlePrevious}
                  currentPage={currentPage}
                  pages={pages}
                />
              </div>
            )}
          </>
        ) : (
          <div className={cx("loading")}>
            <Loading />
          </div>
        )}
      </div>

      <ModalInfo
        info={infoCurrentUser?.data ? infoCurrentUser.data[0] : []}
        onClose={handleClose}
        openDetailPage={handleOpenDetailPage}
        show={isModalInfo}
        loading={infoCurrentUser.loading}
      />

      {showModalPer && (
        <ModalPermission onClose={showListPermission} info={infoCurrentUser?.data ? infoCurrentUser.data[0] : []} count={count} />
      )}
    </>
  );
};

export default User;
